document.addEventListener('DOMContentLoaded', function () {
  const filterButtons = document.querySelectorAll('.blogs-collection-page__filter-button');
  const contentContainer = document.getElementById('blog-content');
  const articleCards = contentContainer.querySelectorAll('.article-card');

  function filterBlogs(selectedTag) {
    filterButtons.forEach((btn) => btn.classList.remove('active'));
    document.querySelector(`[data-filter="${selectedTag}"]`).classList.add('active');

    let visibleCount = 0;

    articleCards.forEach((card) => {
      const cardTags = card.dataset.tags.trim().split(' ');
      const shouldShow = selectedTag === 'all' || cardTags.includes(selectedTag);

      if (shouldShow) {
        card.classList.remove('hidden');
        visibleCount++;
      } else {
        card.classList.add('hidden');
      }
    });

    const existingNoResults = contentContainer.querySelector('.blogs-collection-page__no-results');
    if (existingNoResults) existingNoResults.remove();

    if (visibleCount === 0) {
      const noResultsDiv = document.createElement('div');
      noResultsDiv.className = 'blogs-collection-page__no-results';
      noResultsDiv.innerHTML = '<h3>No posts found</h3><p>Try selecting a different tag.</p>';
      contentContainer.appendChild(noResultsDiv);
    }
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      filterBlogs(button.dataset.filter);
    });
  });
});
